import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight, Camera, Star, Users, Briefcase, Music2, CheckCircle2 } from "lucide-react";

// Press shot gallery images
const galleryImages = [
  {
    url: "https://customer-assets.emergentagent.com/job_14cde54c-7596-4fa6-b447-091e88a18aa7/artifacts/z1qqbm1j_DSC_0004.jpg",
    alt: "Artist Press Shot - Tattoo Artist Portrait"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_14cde54c-7596-4fa6-b447-091e88a18aa7/artifacts/125abo9p_DSC_0351.jpg",
    alt: "Artist Portrait - Casual Style"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_14cde54c-7596-4fa6-b447-091e88a18aa7/artifacts/z3wcr57e_DSC_0369.jpg",
    alt: "Professional Portrait - Seated"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_14cde54c-7596-4fa6-b447-091e88a18aa7/artifacts/e1n1ewo8_DSC_0489.jpg",
    alt: "Artist Press Shot - Masked Performer"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_14cde54c-7596-4fa6-b447-091e88a18aa7/artifacts/mripnvpf_DSC_0506.jpg",
    alt: "Professional Headshot - Business Portrait"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_14cde54c-7596-4fa6-b447-091e88a18aa7/artifacts/386j63gf_DSC_0812.jpg",
    alt: "Artist Portrait - Neovision Style"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_14cde54c-7596-4fa6-b447-091e88a18aa7/artifacts/y4on6br1_DSC_1289.jpg",
    alt: "Full Body Portrait - Urban Style"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_14cde54c-7596-4fa6-b447-091e88a18aa7/artifacts/koq5vbhs_DSC_1645.jpg",
    alt: "Artist Press Shot - Yellow Background"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_14cde54c-7596-4fa6-b447-091e88a18aa7/artifacts/zzac24h5_DSC_2005.jpg",
    alt: "Sports Portrait - Baseball Player"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_14cde54c-7596-4fa6-b447-091e88a18aa7/artifacts/y0w43hoh_DSC_2055.jpg",
    alt: "Professional Portrait - Deus Ex Machina"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_14cde54c-7596-4fa6-b447-091e88a18aa7/artifacts/fmus3ae9_DSC_2381.jpg",
    alt: "Artist Portrait - Crouching Pose"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_14cde54c-7596-4fa6-b447-091e88a18aa7/artifacts/a5myqyv2_DSC_2433.jpg",
    alt: "Professional Portrait - Estilio Style"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_14cde54c-7596-4fa6-b447-091e88a18aa7/artifacts/spfsndzi_DSC_2596.jpg",
    alt: "Artist Press Shot - Kappa Jacket"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_14cde54c-7596-4fa6-b447-091e88a18aa7/artifacts/knrnui8n_DSC_6435.jpg",
    alt: "Artist Portrait - North Face Style"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_14cde54c-7596-4fa6-b447-091e88a18aa7/artifacts/9m9fwg7w_DSC_6481.jpg",
    alt: "Professional Portrait - Sunglasses Style"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_14cde54c-7596-4fa6-b447-091e88a18aa7/artifacts/oyjkcwta_DSC_7227.jpg",
    alt: "Artist Portrait - OG Nerd Hoodie"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_14cde54c-7596-4fa6-b447-091e88a18aa7/artifacts/xp3pa49p_DSC_7329.jpg",
    alt: "Professional Portrait - Truth Serum"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_14cde54c-7596-4fa6-b447-091e88a18aa7/artifacts/htcmiw77_DSC_7635.jpg",
    alt: "Business Portrait - MC with Microphone"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_14cde54c-7596-4fa6-b447-091e88a18aa7/artifacts/oono4dby_DSC_8653.jpg",
    alt: "Full Body Portrait - Carhartt Style"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_14cde54c-7596-4fa6-b447-091e88a18aa7/artifacts/7eiqpyca_DSC_9026.jpg",
    alt: "Artist Portrait - Seated Profile"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_14cde54c-7596-4fa6-b447-091e88a18aa7/artifacts/0s0gqz0m_DSC_9174.jpg",
    alt: "Business Portrait - Professional Woman"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_14cde54c-7596-4fa6-b447-091e88a18aa7/artifacts/sqmht3ws_DSC_9186.jpg",
    alt: "Professional Portrait - Business Man"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_14cde54c-7596-4fa6-b447-091e88a18aa7/artifacts/n8rcwurx_DSC_9844.jpg",
    alt: "Artist Portrait - Casual Seated"
  }
];

const whoIsItFor = [
  {
    icon: Music2,
    title: "Artists & Musicians",
    description: "Album artwork, social media content, press kits, promotional materials"
  },
  {
    icon: Star,
    title: "Creatives & Influencers",
    description: "Personal branding, portfolio shots, social media presence"
  },
  {
    icon: Briefcase,
    title: "Business Professionals",
    description: "LinkedIn headshots, corporate profiles, professional branding"
  },
  {
    icon: Users,
    title: "Bands & Groups",
    description: "Group shots, promotional imagery, event marketing materials"
  }
];

const benefits = [
  "Stand out with professional quality imagery",
  "Build credibility and trust with your audience",
  "Create a consistent brand identity",
  "Get high-resolution files for all uses",
  "Versatile shots for multiple platforms",
  "Expert guidance on poses and styling"
];

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 }
};

export default function Photography() {
  return (
    <div className="pt-20" data-testid="photography-page">
      {/* Hero Section */}
      <section className="py-24 bg-dream-bg relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-dream-violet/10 to-transparent" />
        <div className="max-w-7xl mx-auto px-6 relative">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={fadeInUp}
            className="text-center max-w-3xl mx-auto"
          >
            <div className="w-20 h-20 rounded-2xl bg-dream-violet/10 flex items-center justify-center mx-auto mb-8">
              <Camera className="w-10 h-10 text-dream-violet" />
            </div>
            <p className="text-dream-violet font-mono text-sm tracking-widest mb-4 uppercase">Professional Photography</p>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
              Artist Press Shots & <br />Professional Headshots
            </h1>
            <p className="text-white/60 text-lg mb-8">
              Your image is everything. Whether you're an artist looking to promote your brand, 
              or a professional needing headshots, our studio delivers striking, high-quality photography 
              that makes you stand out.
            </p>
            <Link to="/booking">
              <Button 
                className="bg-dream-violet text-white hover:bg-dream-violet-glow rounded-full px-10 py-6 text-lg font-bold"
                data-testid="hero-book-btn"
              >
                Book Your Session
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
          </motion.div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-16 bg-dream-surface">
        <div className="max-w-7xl mx-auto px-6">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
            className="text-center mb-12"
          >
            <p className="text-dream-violet font-mono text-sm tracking-widest mb-4 uppercase">Our Work</p>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-4">
              Press Shot Gallery
            </h2>
            <p className="text-white/60 max-w-xl mx-auto">
              See the quality of work we deliver. These shots are used for press packs, socials, flyers, and more.
            </p>
          </motion.div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {galleryImages.map((image, index) => (
              <motion.div
                key={index}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeInUp}
                transition={{ delay: index * 0.1 }}
                className="aspect-[4/5] rounded-xl overflow-hidden group"
              >
                <img
                  src={image.url}
                  alt={image.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Professional Photography Matters */}
      <section className="py-24 bg-dream-bg">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUp}
            >
              <p className="text-dream-violet font-mono text-sm tracking-widest mb-4 uppercase">Why It Matters</p>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-6">
                Your Image Is Your Brand
              </h2>
              <p className="text-white/60 mb-6">
                In today's visual world, first impressions happen in milliseconds. A professional, 
                polished image communicates credibility, quality, and attention to detail before 
                you even speak a word.
              </p>
              <p className="text-white/60 mb-8">
                Whether you're pitching to labels, applying for jobs, or building your social media presence, 
                high-quality photography sets you apart from the competition. It shows you take yourself 
                seriously—and so should others.
              </p>
              
              <div className="space-y-3">
                {benefits.map((benefit, index) => (
                  <motion.div
                    key={index}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeInUp}
                    transition={{ delay: index * 0.05 }}
                    className="flex items-center gap-3"
                  >
                    <CheckCircle2 className="w-5 h-5 text-dream-violet flex-shrink-0" />
                    <span className="text-white/80">{benefit}</span>
                  </motion.div>
                ))}
              </div>
            </motion.div>

            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUp}
              className="relative"
            >
              <div className="aspect-[4/5] rounded-2xl overflow-hidden">
                <img
                  src="https://customer-assets.emergentagent.com/job_14cde54c-7596-4fa6-b447-091e88a18aa7/artifacts/koq5vbhs_DSC_1645.jpg"
                  alt="Professional Press Shot Example"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-6 -left-6 glass rounded-xl p-6 max-w-xs">
                <p className="text-white font-heading font-bold mb-1">30+ Edited Photos</p>
                <p className="text-white/60 text-sm">High-resolution files ready for any platform</p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Who Is It For */}
      <section className="py-24 bg-dream-surface">
        <div className="max-w-7xl mx-auto px-6">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
            className="text-center mb-16"
          >
            <p className="text-dream-violet font-mono text-sm tracking-widest mb-4 uppercase">Who It's For</p>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-4">
              Photography For Everyone
            </h2>
            <p className="text-white/60 max-w-xl mx-auto">
              Our photography services cater to a wide range of clients who understand the importance of professional imagery.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {whoIsItFor.map((item, index) => (
              <motion.div
                key={index}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeInUp}
                transition={{ delay: index * 0.1 }}
                className="glow-card p-6 rounded-xl text-center"
              >
                <div className="w-14 h-14 rounded-xl bg-dream-violet/10 flex items-center justify-center mx-auto mb-4">
                  <item.icon className="w-7 h-7 text-dream-violet" />
                </div>
                <h3 className="font-heading text-lg font-bold text-white mb-2">{item.title}</h3>
                <p className="text-white/60 text-sm">{item.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-24 bg-dream-bg">
        <div className="max-w-7xl mx-auto px-6">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
            className="text-center mb-12"
          >
            <p className="text-dream-violet font-mono text-sm tracking-widest mb-4 uppercase">Pricing</p>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-4">
              Photography Packages
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {/* Press Shots Package */}
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUp}
              className="glow-card p-8 rounded-2xl border-dream-violet"
            >
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-dream-violet text-white text-xs font-bold px-4 py-1 rounded-full">
                MOST POPULAR
              </div>
              <h3 className="font-heading text-xl font-bold text-white mb-2 mt-2">Photography (Press Shots)</h3>
              <div className="mb-6">
                <span className="font-mono text-4xl font-bold text-dream-violet">$299.99</span>
              </div>
              <ul className="space-y-3 mb-8">
                <li className="flex items-center gap-3 text-white/80 text-sm">
                  <div className="w-2 h-2 bg-dream-violet rounded-full flex-shrink-0" />
                  30+ Edited High-Resolution Photos
                </li>
                <li className="flex items-center gap-3 text-white/80 text-sm">
                  <div className="w-2 h-2 bg-dream-violet rounded-full flex-shrink-0" />
                  Professional Lighting Setup
                </li>
                <li className="flex items-center gap-3 text-white/80 text-sm">
                  <div className="w-2 h-2 bg-dream-violet rounded-full flex-shrink-0" />
                  Various Backdrop Options
                </li>
                <li className="flex items-center gap-3 text-white/80 text-sm">
                  <div className="w-2 h-2 bg-dream-violet rounded-full flex-shrink-0" />
                  For Artists, Creatives & Business
                </li>
                <li className="flex items-center gap-3 text-white/80 text-sm">
                  <div className="w-2 h-2 bg-dream-violet rounded-full flex-shrink-0" />
                  Files Delivered Digitally
                </li>
              </ul>
              <Link to="/booking">
                <Button className="w-full bg-dream-violet text-white hover:bg-dream-violet-glow rounded-full">
                  Book Now
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </Link>
            </motion.div>

            {/* Dry Hire Package */}
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUp}
              transition={{ delay: 0.1 }}
              className="glow-card p-8 rounded-2xl"
            >
              <h3 className="font-heading text-xl font-bold text-white mb-2">Photography (Dry Hire)</h3>
              <div className="mb-6">
                <span className="font-mono text-4xl font-bold text-dream-violet">$80</span>
                <span className="text-white/50 text-sm">/hour</span>
              </div>
              <ul className="space-y-3 mb-8">
                <li className="flex items-center gap-3 text-white/80 text-sm">
                  <div className="w-2 h-2 bg-dream-violet rounded-full flex-shrink-0" />
                  Studio Space Access
                </li>
                <li className="flex items-center gap-3 text-white/80 text-sm">
                  <div className="w-2 h-2 bg-dream-violet rounded-full flex-shrink-0" />
                  Lighting Equipment Included
                </li>
                <li className="flex items-center gap-3 text-white/80 text-sm">
                  <div className="w-2 h-2 bg-dream-violet rounded-full flex-shrink-0" />
                  Backdrop Options Available
                </li>
                <li className="flex items-center gap-3 text-white/80 text-sm">
                  <div className="w-2 h-2 bg-dream-violet rounded-full flex-shrink-0" />
                  Bring Your Own Photographer
                </li>
                <li className="flex items-center gap-3 text-white/80 text-sm">
                  <div className="w-2 h-2 bg-dream-violet rounded-full flex-shrink-0" />
                  Perfect for Content Creators
                </li>
              </ul>
              <Link to="/booking">
                <Button className="w-full bg-white/10 text-white hover:bg-white/20 rounded-full">
                  Book Now
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </Link>
            </motion.div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-dream-surface">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
          >
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-6">
              Ready to Elevate Your Image?
            </h2>
            <p className="text-white/60 max-w-xl mx-auto mb-8">
              Book your photography session today and get professional press shots that make you stand out.
            </p>
            <Link to="/booking">
              <Button 
                className="bg-white text-black hover:bg-dream-violet hover:text-white rounded-full px-10 py-6 text-lg font-bold transition-all duration-300"
                data-testid="cta-book-btn"
              >
                Book Your Session
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
